(function(){
    angular.module('tmx-app').directive("navTreeView", navTreeViewDirective);

    function navTreeViewDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	          navId:"@",
	          data:"=",
	          children:"@"
	        },
	        templateUrl: 'common/directives/navtreeview/navtreeview.html',
		    controller: ["$scope",navTreeViewCtrl],
		    controllerAs:'navTreeViewCtrl'
	    };
    }

    function navTreeViewCtrl($scope){
        this.scope = $scope;


        this.scope.treeData = new kendo.data.HierarchicalDataSource(
            { 
                data: this.scope.data,
                schema: 
				{
				    model: 
					{
					    children: this.scope.children
					}
				}
            }
        );


    }
})();